import React from 'react';
import { useParams } from 'react-router-dom';
import QuestionDetailScreen from './QuestionDetailScreen';

const QuestionEditScreen: React.FC = () => {
  // In a real app, this would come from authentication context
  const userRole = 'SuperAdmin';
  
  return <QuestionDetailScreen userRole={userRole} mode="edit" />;
};

export default QuestionEditScreen;
